export default __webpack_public_path__ + "static/media/werkstatt_bg.187e6838.jpg";